<script setup lang="ts">
import DesktopModal from './desktop/DesktopModal.vue'
import MobileModal from './mobile/MobileModal.vue'
import {onBeforeUnmount, ref, watch} from 'vue'
import {storeToRefs} from 'pinia'
import {useAssistantConversations} from '@/composables/query/mentor/useAssistantConversations'
import {useAssistantStore} from '@/stores/assistant'
import {useAssistantViewport} from '@/components/assistant/composables/useAssistantViewport'
import {useCompanyStore} from '@/stores/company'
import {usePendingStateChecker} from '@/components/assistant/composables/usePendingStateChecker.js'
import {useAssistantCreditUsage} from '@/composables/query/mentor/useAssistantCreditUsage.js'

const assistantStore = useAssistantStore()
const companyStore = useCompanyStore()
const {id: companyId} = storeToRefs(companyStore)
const {isMobileVersion} = useAssistantViewport()

const hasOpenedOnce = ref(false)

watch(
  () => assistantStore.isVisible,
  (isVisible) => {
    document.body.classList.toggle('assistant-modal-open', isVisible)

    if (isVisible) {
      if (hasOpenedOnce.value) {
        updateCreditUsage()
      }

      hasOpenedOnce.value = true
    }
  },
  {immediate: true}
)

onBeforeUnmount(() => {
  document.body.classList.remove('assistant-modal-open')
})

const {creditUsage, updateCreditUsage} = useAssistantCreditUsage(companyId, {
  enabled: hasOpenedOnce,
})
const {conversations, hasNextPage, isFetchingNextPage, intent} = useAssistantConversations(companyId, {
  enabled: hasOpenedOnce,
})

usePendingStateChecker(companyId, {
  onPendingMessageResolved: updateCreditUsage,
})
</script>

<template>
  <template v-if="companyId">
    <div v-show="assistantStore.isVisible">
      <MobileModal
        v-if="isMobileVersion"
        :company-id="companyId"
        :conversations="conversations"
        :credit-usage="creditUsage"
        :has-next-page="hasNextPage"
        :intent="intent"
        :is-fetching-next-page="isFetchingNextPage"
        @pending-message-resolved="updateCreditUsage"
      />
      <DesktopModal
        v-else
        :company-id="companyId"
        :conversations="conversations"
        :credit-usage="creditUsage"
        :has-next-page="hasNextPage"
        :intent="intent"
        :is-fetching-next-page="isFetchingNextPage"
        @pending-message-resolved="updateCreditUsage"
      />
    </div>
  </template>
</template>
